import { queryOptions } from '@tanstack/react-query';
import { getUserClient } from '@/lib/api-clients';
import { CACHE_TIME_5_MINS } from '@/lib/query-client';
import { queryKeys } from '@/lib/query-keys';

/**
 * Single source of truth for the current user's resolved-permissions query.
 * Consumed by both `useCurrentPermissions` (React tree) and the /setup route
 * guards (`queryClient.ensureQueryData`), so both share one cache entry and
 * one staleness window.
 */
export const mePermissionsQueryOptions = queryOptions({
  queryKey: queryKeys.users.mePermissions(),
  queryFn: () => getUserClient().getMyPermissions(),
  staleTime: CACHE_TIME_5_MINS, // permissions rarely change mid-session
});
